
import './index.less'

import FiveKwhVideo from './sections/five-kwh-video';
import FiveKwhScrollTrigger from './sections/five-kwh-scroll-trigger'
import {fiveKwh3d} from './sections/five-kwh-3d';
import FiveKwhSwiperOne from './sections/five-kwh-swiper-one/index'
import {RegularBanner} from './sections/five-kwh-banner/index'
import './sections/five-compare/index'
import FiveKwhSwiperTwo from './sections/five-kwh-swiper-two/index'
import {fiveKwhApply} from "./sections/five-kwh-apply";
import {fiveKwhAppList} from "./sections/five-kwh-app-list";
import FiveFindOut from "../photovolatic-collection/sections/photovolatic-find-out";
import { Scene } from "../jackery-12th-anniversary/sections/jky-12th-scene";
import ScrollAnimation from './sections/five-kwh-dialog'
import { ProductsSwiper } from '../index-new/sections/index-new-product'

fiveKwh3d();
fiveKwhApply();
fiveKwhAppList();

$(function (){
    new Scene({el: '.five-img-text'})
    // 组件滚动动效
    window.gsap.registerPlugin(window.ScrollTrigger);

    $('.five-kwh-market .five-kwh-item').each(function (){
        const index = $(this).data('index');
        if($(this).hasClass('five-kwh-video')){
            const type = $(this).data('type')
            new FiveKwhVideo(index,type);
        }else if($(this).hasClass('five-kwh-scroll-trigger')){
            new FiveKwhScrollTrigger(`#five-kwh-scroll-trigger-${index}`);
        }
    })

    new FiveFindOut({
        pcEl: ".findout-pc-swiper",
        mbEl: ".findout-mb-swiper",
    })

    // 滚动动画
    if (document.querySelector('.five-kwh--content .scroll-animate')) {
        new ScrollAnimation()
    }
})

document.addEventListener('DOMContentLoaded', () => {
    const initSwiper = (selector, swiperClass, pcClass, mbClass, SwiperConstructor) => {
        const $elements = $(selector);
        if ($elements.length === 0) return;
        $elements.each((i, element) => {
            const $currentSwiper = $(element);
            const swiperIndex = i + 1;
            $currentSwiper.addClass(`${swiperClass}-${swiperIndex}`);
            $currentSwiper.find(`.${pcClass}`).addClass(`${pcClass}-${swiperIndex}`);
            $currentSwiper.find(`.${mbClass}`).addClass(`${mbClass}-${swiperIndex}`);
            new SwiperConstructor({
                wrapEl: `.${swiperClass}-${swiperIndex}`,
                pcEl: `.${pcClass}-${swiperIndex}`,
                mbEl: `.${mbClass}-${swiperIndex}`
            });
        });
    };
    initSwiper('.five-kwh-swiper-one', 'five-kwh-swiper-one', 'five-kwh-one-carousel-pc', 'five-kwh-one-carousel-mb', FiveKwhSwiperOne);
    initSwiper('.five-kwh-swiper-two', 'five-kwh-swiper-two', 'five-kwh-two-carousel-pc', 'five-kwh-two-carousel-mb', FiveKwhSwiperTwo);

    new RegularBanner(document.querySelector('.five-kwh-banner .swiper-container'))
    $('.index-new-products').each(function(){
        const clas = $(this).data('name')
        clas && new ProductsSwiper({el: $(`.${clas}`), clas})
    })
});
